import React from 'react';
import { Star } from 'lucide-react';
import { reviews, GOOGLE_REVIEWS_URL } from '../mock';

const ReviewsSection = () => {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-[#1a1a1a] relative overflow-hidden">
      <div className="max-w-[1280px] mx-auto">
        {/* Title */}
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm text-gray-400 mb-3 tracking-[0.3em] uppercase">
            Customer Reviews
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-white tracking-tight font-display-serif leading-[1.05]">
            What Our Customers Say
          </h2>
          <div className="flex items-center justify-center gap-1 mt-5">
            {[1, 2, 3, 4, 5].map((s) => (
              <Star key={s} className="w-5 h-5 text-yellow-400" fill="#facc15" strokeWidth={0} />
            ))}
            <span className="text-white/80 text-sm ml-2">Real reviews from Google</span>
          </div>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map((r, idx) => (
            <a
              key={idx}
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-[#262626] rounded-2xl p-7 border border-white/5 card-transition hover:border-white/20 hover:bg-[#2a2a2a]"
            >
              <div className="flex items-center gap-4 mb-5">
                <div
                  className={`w-12 h-12 rounded-full ${r.color} flex items-center justify-center text-white font-bold text-lg flex-shrink-0`}
                >
                  {r.initial}
                </div>
                <div className="min-w-0">
                  <h4 className="text-white font-semibold text-lg truncate">{r.name}</h4>
                  <p className="text-gray-400 text-xs truncate">{r.meta}</p>
                </div>
              </div>

              <div className="flex items-center gap-2 mb-4">
                <div className="flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star
                      key={s}
                      className={`w-4 h-4 ${s <= r.rating ? 'text-yellow-400' : 'text-gray-600'}`}
                      fill={s <= r.rating ? '#facc15' : 'transparent'}
                      strokeWidth={s <= r.rating ? 0 : 1.5}
                    />
                  ))}
                </div>
                <span className="text-gray-400 text-xs">{r.time}</span>
              </div>

              <p className="text-gray-300 leading-relaxed text-sm mb-6">{r.text}</p>

              <div className="inline-flex items-center gap-2 text-sm text-gray-400">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    fill="#4285F4"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="#34A853"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="#EA4335"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                <span>Posted on Google</span>
              </div>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white text-white hover:text-black border-2 border-white/40 hover:border-white px-8 py-3 rounded-full text-sm font-medium transition-colors btn-transition"
          >
            Read all reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
